import { createIcon } from '../icons/utils';

/**
 * Letter glyph inside the same filled ring legacy gave the call and SMS channels.
 *
 * Legacy shipped `call-circle.svg` and `msg-circle.svg` but no letter equivalent —
 * it had no letter channel. This composes the existing letter artwork into that ring
 * so the three communication channels read as one family on the lane instead of one
 * of them sitting bare while the others carry a ring.
 *
 * The inner `scale` is composition, not padding: the glyph is a small mark *inside* a
 * ring that is itself the icon, sized to the ~50% of the ring diameter legacy's own
 * handset and bubble occupy. That is the opposite of the `scale(0.8)` wrappers that
 * were removed from the status glyphs, where the artwork *was* the icon and the scale
 * only shrank it.
 */
export const LetterCircleIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.5 24C18.8513 24 24 18.8513 24 12.5C24 6.14873 18.8513 1 12.5 1C6.14873 1 1 6.14873 1 12.5C1 18.8513 6.14873 24 12.5 24Z"
        fill="hsl(var(--primary-100))"
        stroke="hsl(var(--primary-600))"
        strokeWidth={1.2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* The 20x20 letter artwork placed inside the ring: scaled to the ~12.5 units
          legacy's inner glyphs occupy and re-centred on the ring's middle. */}
      <g transform="translate(4.17 4.17) scale(0.833)">
        <path
          d="M7.5 15.4166H12.5M5.83333 12.5H14.1667M4.16667 1.66663H15.8333C16.7538 1.66663 17.5 2.49573 17.5 3.51848V16.4814C17.5 17.5042 16.7538 18.3333 15.8333 18.3333H4.16667C3.24619 18.3333 2.5 17.5042 2.5 16.4814V3.51848C2.5 2.49573 3.24619 1.66663 4.16667 1.66663ZM9.998 5.17657C9.41486 4.52729 8.44243 4.35264 7.71179 4.94719C6.98115 5.54173 6.87828 6.53579 7.45206 7.23896C8.02583 7.94213 9.998 9.58329 9.998 9.58329C9.998 9.58329 11.9702 7.94213 12.5439 7.23896C13.1177 6.53579 13.0274 5.53548 12.2842 4.94719C11.541 4.35889 10.5811 4.52729 9.998 5.17657Z"
          stroke="hsl(var(--primary-600))"
          strokeWidth={1.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  { displayName: 'LetterCircleIcon', defaultSize: 25, classNameBase: '' },
);
